<template>
			<div class="container">
        <div class="content py-4">
            <!-- <img :src="attachments.url" />  -->
            <ul class="attachments" v-if="attachments.length">
              <li v-for="(attachment, index) in attachments" :key="index">
                <div class="img-box">
                  <img :src="attachment.url" />
                </div>
              </li>
            </ul>
            <div class="py-5" v-else>
              <h3>沒有合約附件圖片</h3>
            </div>
       <!-- <v-img :src="attachments.url"/> -->
		</div>
      </div>

</template>

<script>
  export default {
    name: 'MainBody',
    props: {
      attachments: {
        type: Object
      }
    },
    data() {
      return {
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.img-box{
  max-width: 100%;

  img{
    max-width: 100%;
    height: auto;
    width: 100%;
  }
}
.attachments{
  list-style: none;
  padding-left: 0px;
  li{
    list-style: none;
    margin-bottom: 30px;

  }
}
/* h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
} */
</style>
